import PropTypes from 'prop-types';
import React from 'react';

import { QuestionsAndAnswers } from 'js/components/QuestionsAndAnswers';
import styles from './styles.module.css';

const RelatedQuestions = ({ i18n, ctaUri, questions }) => {
  if (!questions || questions.length === 0) {
    return null;
  }

  return (
    <div className={styles.relatedQuestions}>
      <h4 className={styles.header}>
        {i18n('page.question.related-questions')}
      </h4>
      {questions.map((question) => (
        <QuestionsAndAnswers {...question} key={question.id} i18n={i18n} />
      ))}
      <a href={ctaUri} className={styles.cta}>
        {i18n('page.question.show-all-questions')}
      </a>
    </div>
  );
};

RelatedQuestions.propTypes = {
  i18n: PropTypes.func,
  questions: PropTypes.array,
  treatmentUri: PropTypes.string,
  ctaUri: PropTypes.string,
};

export default RelatedQuestions;
